import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/Styles/SimulationCSS/SliderSim.css';

const MTS_SimulationStartInfo = ({ ShowEmailVerification, HideSimualationStartInfo, onSaveSimulationDetails }) => {
    
    const [isTripDetailsVisible, setTripDetailsVisible] = useState(false);
    const [numberOfTrips, setNumberOfTrips] = useState(100);
    const [numberOfVehicles, setNumberOfVehicles] = useState(10);
    const [slotDuration, setSlotDuration] = useState(60);

    const toggleVisibilityOfEmailVerification = () => {
        // Send the values to the parent component
        onSaveSimulationDetails({
            numberOfTrips,
            numberOfVehicles,
            slotDuration
        });

        // Trigger any additional logic like showing email verification
        setTripDetailsVisible(!isTripDetailsVisible);
        ShowEmailVerification(true);
    };

    const onClickCancelHideSimulationInfo = () => {
        try {
            HideSimualationStartInfo(true);
        } catch (error) {
            console.error("Error hiding simulation info:", error);
        }
    };

    return (
        <div id="MTS_Trips_Information_Componenet">
            <h4>Final Steps To Start Simulation</h4>
            
            <label>Trip Demand Per Hour: </label>
            <input 
                type="number" 
                value={numberOfTrips}
                onChange={(e) => setNumberOfTrips(e.target.value)}
                style={{ marginBottom: "10px", height:"40px", fontSize:"larger" }} 
            />

            <label>No of Vehicles: </label>
            <input 
                type="number" 
                value={numberOfVehicles}
                onChange={(e) => setNumberOfVehicles(e.target.value)}
                style={{ marginBottom: "10px" , height:"40px", fontSize:"larger"}} 
            />

            <label>Simulation Duration(Min): </label>
            <input 
                type="number" 
                value={slotDuration}
                onChange={(e) => setSlotDuration(e.target.value)}
                style={{ marginBottom: "10px", height:"40px", fontSize:"larger" }} 
            />

            <div id="MTS_TIC_ButonsDiv">
                <button id="MTS_TIC_CancelBtn" onClick={onClickCancelHideSimulationInfo}>Cancel</button>
                <button id="MTS_TIC_SaveNextBtn" onClick={toggleVisibilityOfEmailVerification}>Next</button>
            </div>
        </div>
    );
};

export default MTS_SimulationStartInfo;
